import React from "react";
import {Modal} from "@mui/material";

export default function BasicModal({children, open, onClose, hideBackdrop, disableScrollLock, style}) {

    return (
        <div>
            {open && (
                <Modal
                    open={open}
                    onClose={onClose}
                    hideBackdrop={hideBackdrop}
                    disableScrollLock={disableScrollLock}
                    style={style}
                >
                    {children}
                </Modal>
            )}
        </div>
    );
}